module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN336_841711626.e3a15607.png";